import get from 'lodash/get'
import { useDomains } from '../../contexts/DomainsContext'
import { useIngresses } from '../../contexts/IngressesContext'
import DomainChip from './DomainChip'

function ServiceDomainsChips({ serviceId }) {
  const { domainsById } = useDomains()
  const { ingressesByServiceId } = useIngresses()

  const ingresses = get(ingressesByServiceId, serviceId, [])

  return ingresses.map((ingress) => {
    const domainIds = get(ingress, 'domainIds', [])
    const path = get(ingress, 'path', '')

    return domainIds.map((domainId) => {
      const domain = get(domainsById, domainId)
      if (!domain) return null

      return (
        <DomainChip
          key={`${ingress.id}-${domain.id}`}
          domain={domain}
          path={path}
        />
      )
    })
  })
}

export default ServiceDomainsChips
